import {
  CURRENT_LOCALE,
  DEFAULT_LANG,
  LANGUAGE_LIST,
  LANGUAGES_WITHOUT_DEFAULT,
} from "../../config/locale_config";
import {LOCALE_PARAM} from "../../router";

export default {
  actions: {
    actionChangeLocale:(context, {vue = null,lang = DEFAULT_LANG, push_state = true}) => {
      if(!vue) return
      vue.$i18n.locale = lang
      let route_params = vue.$route.params
      route_params[LOCALE_PARAM] = lang
      let new_route = vue.$router.resolve({
        name: vue.$route.name,
        params: route_params,
      })
      if (push_state) {
        history.pushState({}, '', `${location.origin}${new_route.href}`)
      }
      context.dispatch('actionSelectedLanguage', lang)
    },
    actionSelectedLanguage:(context, lang = DEFAULT_LANG) => context.commit('mutationSelectedLanguage', lang),
    actionRouterRedirecting:(context, bool = false) => context.commit('mutationRouterRedirecting', bool),
  },
  mutations: {
    mutationSelectedLanguage: (state, lang) => state.selected_language = lang,
    mutationRouterRedirecting: (state, bool) => state.router_redirecting = bool,
  },
  state: {
    selected_language: CURRENT_LOCALE,
    router_redirecting: false
  },
  getters: {
    getSelectedLanguage: state => state.selected_language,
    getSelectedLanguageNotDefault: (state, getters) => getters.getLanguagesWithoutDefault.includes(state.selected_language),
    getLanguages: state => LANGUAGE_LIST,
    getLanguageWithoutSelected: state => LANGUAGE_LIST.filter(lang => lang !== state.selected_language),
    getLanguagesWithoutDefault: state => LANGUAGES_WITHOUT_DEFAULT,
    getRouterRedirecting: state => state.router_redirecting,
  }
}
